import { LayoutHOC } from 'base/ui/layout/layout';
import { utilitiesRoute } from './routes';
import createPageArchives from './archives';
import CreateUpdatePage from './archives/CreateUpdatePage';
import createArchivesList from './archives/TabList';

export const createUtilitiesPage = (layoutHOC: LayoutHOC) => {
  const Archives = createArchivesList();
  // const AddArchive = createUpdatePage();
  // const EditArchive = createUpdatePage();

  const PageUtilities = layoutHOC(utilitiesRoute);
  return () => (
    <PageUtilities
      Archives={Archives}
    // AddArchive={AddArchive}
    // EditArchive={EditArchive}
    />
  );
};
